import {
  BookOpen,
  Calendar,
  FileText,
  Heart,
  Home,
  Info,
  PenSquare,
  Phone,
  Settings,
  User,
  Users,
} from 'lucide-react';

export interface NavItem {
  label: string; // Changed from category to label
  href: string; // Changed from link to href
  description?: string;
  submenu?: NavItem[];
  icon?: JSX.Element;
  ariaLabel?: string;
}

export const navItem: NavItem[] = [
  {
    label: 'Home',
    href: '/home',
    icon: <Home size={16} />,
    ariaLabel: 'Go to Home',
  },
  {
    label: 'How We Treat',
    href: '/how-we-treat',
    icon: <Heart size={16} />,
    ariaLabel: 'Learn about our treatment methods',
    submenu: [
      {
        label: 'Shock Wave Therapy',
        href: '/how-we-treat/shock-wave-therapy',
        description:
          'Utilize Shock Wave Therapy to treat musculoskeletal conditions, promoting healing and reducing pain effectively.',
        icon: <Heart size={16} />,
      },
    ],
  },
  {
    label: 'About',
    href: '/about',
    icon: <Info size={16} />,
    ariaLabel: 'Learn more about us',
  },
  {
    label: 'Contact',
    href: '/contact',
    icon: <Phone size={16} />,
    ariaLabel: 'Get in touch with us',
  },
  {
    label: 'Appointment',
    href: '/appointment',
    icon: <Calendar size={16} />,
    ariaLabel: 'Schedule an appointment',
  },
  {
    label: 'Specialists',
    href: '/specialists',
    icon: <Users size={16} />,
    ariaLabel: 'Meet our specialists',
  },
  {
    label: 'Blog',
    href: '/blog',
    icon: <PenSquare size={16} />,
    ariaLabel: 'Read our blog',
  },
];

export const UserNavLinks: NavItem[] = [
  {
    label: 'Profile',
    href: '/profile',
    icon: <User size={16} />,
    ariaLabel: 'View Profile',
  },
  {
    label: 'Test Report',
    href: '/profile/report',
    icon: <FileText size={16} />,
    ariaLabel: 'View Test Report',
  },
  {
    label: 'Courses',
    href: '/profile/course',
    icon: <BookOpen size={16} />,
    ariaLabel: 'View Courses',
  },
  {
    label: 'Settings',
    href: '/profile/settings',
    icon: <Settings size={16} />,
    ariaLabel: 'View Settings',
  },
];
